import { useCallback } from 'react';

const useHandleSubmit = ({
    input,
    setInput,
    onSubmit,
    handleSetMessage,
    scrollToBottom,
    handleIntent,
    setMessages,
    setIsInputDisabled,
    setIsMenuDisabled,
    processLinks,
    addGetQuotes,
    setHideChiclets
}) => {
    return useCallback(async (e) => {
        e.preventDefault();
        const currentInput = input.trim();

        if (!currentInput) {
            alert("Input is empty");
            return;
        }

        if (currentInput.toLowerCase() === "exit" || currentInput.toLowerCase() === "clear") {
            setMessages([]);
            handleSetMessage(`Please let me know if you need anymore help!`, "system");
            return;
        }

        handleSetMessage(currentInput, "user");
        setInput("");
        handleSetMessage("Loading...", "system");
        setIsInputDisabled(true);
        setIsMenuDisabled(true);
        setHideChiclets(true);
        setTimeout(() => {
            scrollToBottom();
        }, 100);
        try {
            const res = await onSubmit(currentInput);
            setMessages((prevMessages) =>
                prevMessages.filter((msg) => msg.text !== "Loading...")
            );
            if (res.intent) {
                handleIntent(res.intent, currentInput);
            } else {
                const processedOutput = processLinks(res.output);
                const finalProcessedOutput = addGetQuotes(processedOutput);
                handleSetMessage(finalProcessedOutput, "system");
                setIsInputDisabled(false);
                setIsMenuDisabled(false);
            }
        } catch (error) {
            console.error("Error in handleSubmit:", error);
            handleSetMessage("Failed to get response. Please try again later.", "system");
            setIsInputDisabled(false);
            setMessages((prevMessages) =>
                prevMessages.filter((msg) => msg.text !== "Loading...")
            );
        } finally {
            setTimeout(() => {
                scrollToBottom();
            }, 100);
        }
        
    }, [input,handleSetMessage, setInput, setIsInputDisabled, setIsMenuDisabled,setMessages, scrollToBottom, onSubmit, handleIntent, processLinks, addGetQuotes, setHideChiclets]);
};

export default useHandleSubmit;
